import FormattedMessage from 'I18n/components/FormattedMessage';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import { H2 } from 'UIComponents/elements/headings';
import UIFlex from 'UIComponents/layout/UIFlex';
import styled from 'styled-components';
import { getProductNameTextFromApiName } from '../../../common/adapters/getProductNameText';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TrialTitle = styled(H2).withConfig({
  displayName: "Tx120SurveyModalHeader__TrialTitle",
  componentId: "sc-7cu7mt-0"
})(["font-weight:400 !important;font-size:22px !important;"]);
const ModalTitle = styled(H2).withConfig({
  displayName: "Tx120SurveyModalHeader__ModalTitle",
  componentId: "sc-7cu7mt-1"
})(["font-size:24px !important;"]);
export const TX120SurveyModalHeader = ({
  apiName,
  modalTitle
}) => {
  const productName = getProductNameTextFromApiName(apiName);
  return /*#__PURE__*/_jsx(UIDialogHeader, {
    children: /*#__PURE__*/_jsxs(UIFlex, {
      direction: "column",
      align: "center",
      justify: "center",
      className: "text-center",
      children: [/*#__PURE__*/_jsx(TrialTitle, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.tx0120.common.trialTitle",
          options: {
            productName
          }
        })
      }), /*#__PURE__*/_jsx(ModalTitle, {
        children: modalTitle || /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.tx0120.common.modalTitle"
        })
      })]
    })
  });
};